import React, { useState, useEffect } from "react";
import { IoSearch } from "react-icons/io5";
import { searchapi } from "../../services/Apis"; // Import API function
import { GoArrowUpLeft } from "react-icons/go";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { pushToDataLayer } from "../utils/dataUserpush";
const Search = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    const [isFocused, setIsFocused] = useState(false);
    const smallcsreen = useMediaQuery({ query: '(max-width: 991px)' })
    const navigate = useNavigate()
    const clearSearch = () => {
        setSearchQuery("");
        setSearchResults([]);
        setShowDropdown(false);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            if (searchResults.length > 0) {
                // alert()
                if (!searchQuery.trim()) return;
                const pageName = window.location.pathname;
                // const user_id = localStorage.getItem("user_id") || "guest"; 
                const term = searchQuery;
                // Push event to GTM Data Layer
                pushToDataLayer("clicked_search", currentcountry.name, {
                    search_query: searchQuery,
                    page_name: pageName,
                    // user_id: user_id,
                    term: term,
                }, false);
                if (searchResults[0].hasOwnProperty("url")) {
                    navigate(searchResults[0].url)
                } else {
                    navigate(
                        `/search-result/${event.target.value}`
                    );
                }
            }
        }
    }

    const handleSearch = (event) => {
        if (searchResults.length > 0) {
            // alert()
            if (!searchQuery.trim()) return;
            const pageName = window.location.pathname;
            // const user_id = localStorage.getItem("user_id") || "guest"; 
            const term = searchQuery;
            // Push event to GTM Data Layer
            pushToDataLayer("clicked_search", currentcountry.name, {
                search_query: searchQuery,
                page_name: pageName,
                // user_id: user_id,
                term: term,
            }, false);
            if (searchResults[0].hasOwnProperty("url")) {
                navigate(searchResults[0].url)
            } else {
                navigate(
                    `/search-result/${searchQuery}`
                );
            }
        }
    }


    useEffect(() => {
        const fetchResults = async () => {
            if (searchQuery.length > 1) {
                try {
                    const results = await searchapi(searchQuery);
                    setSearchResults(results?.data?.products || []);
                    setShowDropdown(true);
                } catch (error) {
                    setSearchResults([]);
                }
            } else {
                setSearchResults([]);
                setShowDropdown(false);
            }
        };

        fetchResults(); // Call API immediately when `searchQuery` changes
    }, [searchQuery]);

    const handlenavigate = (item) => {
        if (item?.url) {
            if (item.type === "detail") {
                navigate(`/details/${item.url}`);
            } else if (item.type === "search_redirect") {
                navigate(item.url); // this is already in /brands/... format
            } else if (item.type === "subcategory")  {
                navigate(`${item.url}`);
            }else if (item.type === "brands")  {
                navigate(`${item.url}`);
            }else{
                navigate(`/search-result/${item.title}?subcategory=${item.subcategory_id}_${item.category_id}`);
            }
        } else {
            navigate(`/search-result/${item.title}?subcategory=${item.subcategory_id}_${item.category_id}`);
        }
    };


    // Function to highlight search term in results
    const highlightMatch = (text) => {
        if (!searchQuery) return text;
        const regex = new RegExp(`(${searchQuery})`, "gi");
        return text.replace(regex, `<span class="highlight">${searchQuery}</span>`);
    };

    return (
        <div
            className="d-flex header-searchmain position-relative"
            onMouseEnter={() => searchResults.length > 0 && setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
        >
            <input
                type="text"
                placeholder="What are you looking for?"
                className="header-inputbox"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => {
                    setIsFocused(true);
                    searchResults.length > 0 && setShowDropdown(true);
                }}
                onKeyDown={handleKeyDown}
                onBlur={() => {
                    setIsFocused(false);
                    setTimeout(() => setShowDropdown(false), 200);
                }}
            />
            <div className="header-search secondarybackground" onClick={handleSearch}><img src={'/assets/vector_icons/search.png'} /></div>
            {smallcsreen && (searchQuery || isFocused) && (
                <div className="searchcanclebtn" onClick={clearSearch}>
                    Cancle <MdClose size={10} className="ms-1" />
                </div>
            )}
            {/* Search Dropdown */}
            {showDropdown && (
                <div
                    className="search-dropdown p-3"
                    onMouseEnter={() => setShowDropdown(true)}
                // onMouseLeave={() => setShowDropdown(false)}
                >
                    {searchResults.length > 0 ? (
                        searchResults.map((item) => (
                            <div key={item.url} className="search-item d-flex align-items-center" onClick={() => handlenavigate(item)}>
                                <div className="d-flex justify-content-between align-items-start w-100">
                                    <div className="d-flex align-items-start">
                                        <div style={{ width: '23px', height: '20px' }} className="d-flex align-items-center justify-content-center mt-1">
                                            <IoSearch size={16} className="iconcolor" />
                                        </div>
                                        <div className="ms-2">
                                            {
                                                item.hasOwnProperty('title') ?
                                                    <div
                                                        className="search-title"
                                                        style={{ width: '100%' }}
                                                        dangerouslySetInnerHTML={{ __html: highlightMatch(item.title) }}
                                                    />
                                                    :
                                                    <div>no tilte</div>
                                            }

                                            <div className="search-title">
                                                {item.small_title}
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ width: '23px', height: '20px' }} className="d-flex align-items-center justify-content-center mt-1">
                                        <GoArrowUpLeft size={16} className="iconcolor mt-1" />
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="search-item">No results found</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Search;
